var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreatePlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 3.625C6.20304 3.625 3.125 6.70304 3.125 10.5C3.125 14.297 6.20304 17.375 10 17.375C13.797 17.375 16.875 14.297 16.875 10.5C16.875 6.70304 13.797 3.625 10 3.625ZM1.875 10.5C1.875 6.01269 5.51269 2.375 10 2.375C14.4873 2.375 18.125 6.01269 18.125 10.5C18.125 14.9873 14.4873 18.625 10 18.625C5.51269 18.625 1.875 14.9873 1.875 10.5Z",
    fill: "#15181E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.25 10.5C6.25 10.1548 6.52982 9.875 6.875 9.875H13.125C13.4702 9.875 13.75 10.1548 13.75 10.5C13.75 10.8452 13.4702 11.125 13.125 11.125H6.875C6.52982 11.125 6.25 10.8452 6.25 10.5Z",
    fill: "#15181E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 6.75C10.3452 6.75 10.625 7.02982 10.625 7.375V13.625C10.625 13.9702 10.3452 14.25 10 14.25C9.65482 14.25 9.375 13.9702 9.375 13.625V7.375C9.375 7.02982 9.65482 6.75 10 6.75Z",
    fill: "#15181E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreatePlusIcon);
export default __webpack_public_path__ + "static/media/create-plus-icon.f88897aaf86e50d045045cc9bd5f9947.svg";
export { ForwardRef as ReactComponent };